import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./application-search.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./application-search.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild, } from "@angular/core";
import { ApplicationSearchConstants } from "./application-search.constants";
import { ApplicationSearchService } from "./shared/services/application-search.service";
import { forkJoin, map, of } from "rxjs";
import { AppControllerService } from "../../app-controller.service";
import { RequestStatusService } from "../../shared/services/request-status/request-status.service";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CRUDOperation } from "../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../shared/models/alert";
import { AppRoutingConstants } from "../../app-routing.constants";
import { ViewApplicationRoutingConstants } from "../../application/view-application/view-application-routing.constants";
import { Router } from "@angular/router";
import { catchError, take } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiLookupConstants } from "../../shared/constants/api-constants/api-lookup.constants";
import { LookupConstants } from "../../shared/constants/lookup.constants";
import { CreateApplicationRoutingConstants } from "../../application/create-application/create-application-routing.constants";
import { AflaModuleStrategyService } from "../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SystemModuleSettingsService } from "../../shared/services/system-module-settings.service";
import { ViewApplicationService } from "../../application/view-application/view-application.service";
import { RouterParamsService } from "../../shared/services/route-params.service";
import { aflaModuleServiceProvider } from "../../shared/services/afla-module-strategy/afla-module-strategy.service.provider";
import { ModuleRoleService } from "../../core/settings/shared/module-role.service";
let ApplicationSearchComponent = class ApplicationSearchComponent {
    router;
    applicationSearchService;
    appControllerService;
    changeDetectorRef;
    requestStatusService;
    http;
    moduleStrategyService;
    systemModuleSettingsService;
    viewApplicationService;
    routeParamsService;
    moduleRoleService;
    acc;
    disableAccordian = false;
    pageHeading = ApplicationSearchConstants.PAGE_HEADING;
    attributeColumnToItemPropertyMap;
    dataSource;
    parentComponent = ApplicationSearchConstants.PARENT_COMPONENT_NAME;
    applicationStatus;
    selectedModuleID;
    searchForm;
    filterForm;
    searchOptionFormControl = ApplicationSearchConstants.SEARCH_OPTION_CONTROL;
    selectOptionFormControl = ApplicationSearchConstants.SELECT_OPTION_CONTROL;
    filterNameText = ApplicationSearchConstants.FILTER_NAME_TEXT;
    //public readonly filterTypeText = ApplicationSearchConstants.FILTER_TYPE_TEXT;
    filterOperatorText = ApplicationSearchConstants.FILTER_OPERATOR_TEXT;
    valueOperatorText = ApplicationSearchConstants.VALUE_OPERATOR_TEXT;
    whereTooltipText = ApplicationSearchConstants.WHERE_TOOLTIP_TEXT;
    filterNameTooltipText = ApplicationSearchConstants.FILTER_NAME_TOOLTIP_TEXT;
    filterOperatorTooltipText = ApplicationSearchConstants.FILTER_OPERATOR_TOOLTIP_TEXT;
    filterValueTooltipText = ApplicationSearchConstants.FILTER_VALUE_TOOLTIP_TEXT;
    descriptionLabel1 = ApplicationSearchConstants.DESCRIPTION_LABEL1;
    descriptionLabel2 = ApplicationSearchConstants.DESCRIPTION_LABEL2;
    descriptionLabel3 = ApplicationSearchConstants.DESCRIPTION_LABEL3;
    searchOptionFormControlLabel = ApplicationSearchConstants.SEARCH_OPTION_CONTROL_LABEL;
    selectOptionFormControlLabel = ApplicationSearchConstants.SELECT_OPTION_CONTROL_LABEL;
    lookupValuePlaceholder = ApplicationSearchConstants.LOOKUP_VALUE_PLACEHOLDER;
    lookupSimplePlaceholder = ApplicationSearchConstants.LOOKUP_SIMPLE_PLACEHOLDER;
    queryBuilderHeadingLabel = ApplicationSearchConstants.QUERY_BUILDER_HEADING_LABEL;
    searchResultsHeadingLabel = ApplicationSearchConstants.SEARCH_RESULTS_HEADING_LABEL;
    selectAllLabel = ApplicationSearchConstants.SELECT_ALL_LABEL;
    showHideColumnsLabel = ApplicationSearchConstants.SHOW_HIDE_COLUMNS_LABEL;
    userSearchPlaceholder = ApplicationSearchConstants.USER_SEARCH_PLACEHOLDER;
    resetLabel = ApplicationSearchConstants.RESET_LABEL;
    searchLabel = ApplicationSearchConstants.SEARCH_LABEL;
    addListItemText = ApplicationSearchConstants.ADD_ITEM_LABEL;
    showFieldSelector = false;
    getModuleTemplatesSubscription;
    getSystemModuleUsersSubscription;
    getSearchesSubscription;
    getLookUpsSubscription;
    listenForModuleIDChangesSubscription;
    lookups = [];
    moduleUsers = [];
    searches = [];
    selectedSearchConfiguration = [];
    columns = [];
    filters = [];
    showWhereSection = false;
    showHideColumns = false;
    operatorOptions = ApplicationSearchConstants.OPERATORS;
    loaded = false;
    expandSummaryButtonText = "summary";
    showSummary = false;
    createApplicationLinkText;
    dropdownSettings = {
        singleSelection: false,
        idField: "item_id",
        textField: "item_text",
        allowSearchFilter: true,
        selectAllText: "Select All",
        unSelectAllText: "Unselect All",
        itemsShowLimit: 4
    };
    constructor(router, applicationSearchService, appControllerService, changeDetectorRef, requestStatusService, http, moduleStrategyService, systemModuleSettingsService, viewApplicationService, routeParamsService, moduleRoleService) {
        this.router = router;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.moduleStrategyService = moduleStrategyService;
        this.systemModuleSettingsService = systemModuleSettingsService;
        this.viewApplicationService = viewApplicationService;
        this.routeParamsService = routeParamsService;
        this.moduleRoleService = moduleRoleService;
        this.createApplicationLinkText = "Create application";
    }
    ngOnInit() {
        this.requestStatusService.showBusySpinner("InitialPageLoad");
        if (!this.applicationStatus)
            this.listenForModuleIDChanges();
        this.initForms();
        this.loadInitialData();
    }
    loadInitialData() {
        forkJoin({
            lookups: this.getLookUps(),
            moduleUsers: this.getModuleUsers()
        }).subscribe({
            next: ({ lookups, moduleUsers }) => {
                // Both completed — assign results and continue
                const lookupsTemp = lookups;
                this.moduleUsers = moduleUsers;
                this.getSearches(); // moved here from inside getLookUps
                this.dataSource = of([]);
                this.attributeColumnToItemPropertyMap = new Map();
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(ApplicationSearchConstants.COMPONENT_NAME, error, CRUDOperation.Get);
            }
        });
    }
    listenForModuleIDChanges() {
        const onlyValidParams = this.routeParamsService.params;
        this.listenForModuleIDChangesSubscription = onlyValidParams.subscribe((routeParamsChange) => {
            if (routeParamsChange.moduleid) {
                this.handleModuleIDChange(routeParamsChange.moduleid);
            }
        });
    }
    handleModuleIDChange(moduleID) {
        if (moduleID) {
            this.selectedModuleID = moduleID;
            this.createApplicationLinkText = this.moduleStrategyService.dynamicTitle.CreateApplicationLinkText;
            this.pageHeading = this.moduleStrategyService.dynamicTitle.Applications;
            this.systemModuleSettingsService.SetsubscribToStrategyServiceSubject(this.moduleStrategyService.dynamicTitle);
            this.viewApplicationService.nextTitles(this.moduleStrategyService.dynamicTitle);
            this.viewApplicationService.setViewApplicationMenuLinks(this.moduleStrategyService.viewApplicationMenuHeadings);
            this.changeDetectorRef.markForCheck();
            console.log(this.selectedModuleID);
        }
    }
    initForms() {
        this.searchForm = new FormGroup({
            searchOptionFormControl: new FormControl(null, [Validators.required]),
            selectOptionFormControl: new FormControl(null, [Validators.required])
        });
        this.filterForm = new FormGroup({});
    }
    ngAfterViewInit() {
        this.requestStatusService.removeBusySpinner("InitialPageLoad");
    }
    ngOnDestroy() {
        this.dataSource = null;
        this.changeDetectorRef.detectChanges();
    }
    getModuleUsers() {
        return this.moduleRoleService.getModuleUsersIncludingSysAdmin(this.selectedModuleID).pipe(take(1));
    }
    getSearches() {
        this.searches = [];
        this.getSearchesSubscription = this.applicationSearchService.getApplicationSearches(+this.appControllerService.selectedModuleID).subscribe({
            next: (response) => {
                if (response !== null && response.value.length === 0) {
                    this.acc.collapseAll();
                    this.appControllerService.showMessage(ApplicationSearchConstants.NO_SEARCHES_MESSAGE, AlertType.Warning);
                    this.disableAccordian = true;
                    return;
                }
                response.value.forEach(element => {
                    if (element.disabled === false) {
                        this.searches.push(element);
                    }
                });
                this.disableAccordian = false;
                this.changeDetectorRef.detectChanges();
                const defaultSearch = this.searches.find(x => x.default === true);
                if (defaultSearch !== null && defaultSearch !== undefined) {
                    this.searchForm.get(this.searchOptionFormControl).setValue(defaultSearch.name);
                }
                else {
                    this.searchForm.get(this.searchOptionFormControl).setValue(this.searches[0].name);
                }
                this.updateFrom();
                // activate the search initial load
                this.onBtnSearchClicked();
                this.requestStatusService.removeBusySpinner("InitialPageLoad");
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(ApplicationSearchConstants.COMPONENT_NAME, error, CRUDOperation.Get);
                this.requestStatusService.removeBusySpinner("InitialPageLoad");
            }
        });
    }
    onBtnResetClicked() {
        this.attributeColumnToItemPropertyMap = new Map();
        this.dataSource = of([]);
        this.columns = [];
        this.filters = [];
        this.searchForm.get(this.selectOptionFormControl).disable();
        this.searchForm.get(this.selectOptionFormControl).setValue("");
        this.searchForm.reset();
        this.filterForm.reset();
        this.selectedSearchConfiguration = [];
        this.filterForm = new FormGroup({});
        this.showWhereSection = false;
        this.showFieldSelector = false;
        this.showHideColumns = false;
        this.acc.collapseAll();
        this.getSearches();
    }
    onBtnSearchClicked() {
        let rawDisplayFields = this.searchForm.get(this.selectOptionFormControl).value;
        if (!rawDisplayFields || rawDisplayFields.length === 0) {
            rawDisplayFields = this.selectedSearchConfiguration.displayFields.map(x => x.name);
        }
        if (!rawDisplayFields || rawDisplayFields.length === 0) {
            this.searchForm.get(this.selectOptionFormControl).markAsTouched();
            this.changeDetectorRef.detectChanges();
            this.appControllerService.showMessage(ApplicationSearchConstants.NO_SEARCH_SELECTED, AlertType.Warning);
            return;
        }
        const requestObj = {};
        requestObj.moduleId = +this.appControllerService.selectedModuleID;
        requestObj.searchViewId = +this.selectedSearchConfiguration.id;
        requestObj.displayFields = [];
        requestObj.filters = [];
        this.dataSource = of([]);
        // display fields
        rawDisplayFields.forEach(item => {
            const field = this.columns.find(x => x.name === item);
            if (field !== null && field !== undefined) {
                requestObj.displayFields.push(field);
            }
        });
        if (requestObj.displayFields.length === 0) {
            this.appControllerService.showMessage(ApplicationSearchConstants.NO_DISPLAY_FIELDS_SELECTED, AlertType.Warning);
            return;
        }
        // filters
        this.filters.forEach(filter => {
            if (filter.type === "list") {
                const valueList = [];
                filter.listControls.forEach(control => {
                    const val = this.filterForm.get(control).value;
                    if (val !== null && val !== undefined && val !== "") {
                        valueList.push(`'${this.filterForm.get(control).value}'`);
                    }
                });
                filter.value = valueList.join(",");
                requestObj.filters.push(filter);
            }
            else if (filter.type === "SYSTEM_ASSIGNED_TO") {
                const valueList = [];
                const values = this.filterForm.get(filter.filterValueControl).value;
                values.forEach(value => {
                    const val = value.item_id;
                    if (val !== null && val !== undefined && val !== "") {
                        valueList.push(val.toString());
                    }
                });
                filter.value = valueList.join(",");
                requestObj.filters.push(filter);
            }
            else if (filter.type === "stored procedure") {
                filter.operator = this.filterForm.get(filter.filterOperatorControl).value;
                filter.value = this.filterForm.get(filter.filterValueControl).value;
                if (filter.value === null) {
                    filter.value = null;
                }
                else {
                    filter.value = filter.value.toString();
                }
                requestObj.filters.push(filter);
            }
            else {
                filter.operator = this.filterForm.get(filter.filterOperatorControl).value;
                filter.value = this.filterForm.get(filter.filterValueControl).value;
                if (filter.value !== null && filter.value !== undefined) {
                    filter.value = filter.value.toString();
                    requestObj.filters.push(filter);
                }
            }
        });
        this.executeSearchQuery(requestObj);
    }
    executeSearchQuery(requestObj) {
        this.mapColumns(requestObj.displayFields);
        this.changeDetectorRef.detectChanges();
        this.dataSource = this.applicationSearchService.doApplicationSearch(requestObj)
            .pipe(map(data => {
            const values = [];
            if (data !== null && data !== undefined && data.value.length !== 0) {
                data.value.forEach(item => {
                    let record = {
                        key: item.key,
                    };
                    if (item.extendedProperties !== null) {
                        for (const [key, value] of Object.entries(item.extendedProperties)) {
                            record[key] = value;
                        }
                    }
                    values.push(record);
                });
                return values;
            }
            else {
                this.appControllerService.showMessage(ApplicationSearchConstants.NO_RESULTS_FOUND, AlertType.Warning);
            }
        }), catchError(error => {
            this.dataSource = of([]);
            this.appControllerService.handleServerErrorMessage(ApplicationSearchConstants.COMPONENT_NAME, error, CRUDOperation.Get);
            return this.dataSource;
        }));
        this.acc.collapseAll();
        this.acc.toggle("resultGrid");
    }
    mapColumns(fields) {
        this.attributeColumnToItemPropertyMap = new Map();
        fields.forEach(item => {
            this.attributeColumnToItemPropertyMap.set(item.alias, item.name);
        });
        this.changeDetectorRef.detectChanges();
    }
    updateFrom() {
        this.showWhereSection = true;
        this.showFieldSelector = true;
        this.columns = [];
        this.filters = [];
        this.filterForm = new FormGroup({});
        this.searchForm.get(this.selectOptionFormControl).setValue(null);
        const selectedValue = this.searchForm.get(this.searchOptionFormControl).value;
        this.selectedSearchConfiguration = this.searches.find(x => x.name === selectedValue);
        if (this.selectedSearchConfiguration.displayFields.length === 0 || this.selectedSearchConfiguration.filters.length === 0) {
            this.appControllerService.showMessage(ApplicationSearchConstants.SEARCH_CONFIG_INCOMPLETE_MESSAGE, AlertType.Warning);
            return;
        }
        this.selectedSearchConfiguration.displayFields.forEach(item => {
            item.alias = this.addSpaceBeforeCapital(item.alias);
        });
        this.bindDisplayColumns();
        this.bindFilters();
        this.changeDetectorRef.detectChanges();
    }
    updateSelect() {
        const valueFromControl = this.searchForm.get(this.selectOptionFormControl).value;
        const selectAll = valueFromControl.find(x => x.toLowerCase() === "select all");
        if (selectAll !== null && selectAll !== undefined && selectAll.length > 0) {
            const selectionMap = this.selectedSearchConfiguration.displayFields.map(x => x.name);
            this.searchForm.get(this.selectOptionFormControl).setValue(selectionMap);
        }
        this.changeDetectorRef.detectChanges();
    }
    bindDisplayColumns() {
        this.columns = this.selectedSearchConfiguration.displayFields.sort((a, b) => (a.order < b.order ? -1 : 1));
        if (this.columns.length === 0) {
            this.searchForm.get(this.selectOptionFormControl).disable();
            this.searchForm.get(this.selectOptionFormControl).setValue("");
        }
        else {
            this.searchForm.get(this.selectOptionFormControl).enable();
            const selectionMap = this.selectedSearchConfiguration.displayFields.map(x => x.name);
            this.searchForm.get(this.selectOptionFormControl).setValue(selectionMap);
        }
    }
    addSpaceBeforeCapital(input) {
        // Trim to remove leading/trailing spaces
        let trimmed = input.trim();
        // If empty string, return as is
        if (trimmed.length === 0) {
            return "";
        }
        // 1. Insert space between lowercase and uppercase letters
        trimmed = trimmed.replace(/([a-z])([A-Z])/g, "$1 $2");
        // 2. Insert space between an acronym and the next word
        trimmed = trimmed.replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");
        return trimmed;
    }
    bindFilters() {
        this.addAssignedToFilter();
        let filterCounter = 0;
        this.selectedSearchConfiguration.filters.forEach(item => {
            item.filterNameControl = `${item.name}_${filterCounter}_NAME_CONTROL`;
            item.filterTypeControl = `${item.name}_${filterCounter}_TYPE_CONTROL`;
            item.filterOperatorControl = `${item.name}_${filterCounter}_OPERATOR_CONTROL`;
            const displayField = this.selectedSearchConfiguration.displayFields.find(field => field.name === item.name);
            let filterLabel = item.name;
            if (item.alias !== null) {
                filterLabel = item.alias;
            }
            if (displayField) {
                filterLabel = displayField.alias;
            }
            this.filterForm.addControl(item.filterNameControl, new FormControl(this.addSpaceBeforeCapital(filterLabel)));
            this.filterForm.addControl(item.filterTypeControl, new FormControl(item.type));
            this.filterForm.addControl(item.filterOperatorControl, new FormControl(item.operator));
            this.filterForm.get(item.filterNameControl).disable();
            this.filterForm.get(item.filterTypeControl).disable();
            if (item.type === "SYSTEM_ASSIGNED_TO") {
                item.lookupData = [{ item_id: "@Me", item_text: "@Me" }, { item_id: "@Unassigned", item_text: "@Unassigned" }];
                item.lookupData.push(...this.moduleUsers.map(user => ({
                    item_id: user.id,
                    item_text: `${user.firstName} ${user.lastName} (${user.email})`
                })));
                item.value = [{ item_id: "@Me", item_text: "@Me" }];
            }
            if (item.type === "lookup - db") {
                if (this.lookups.length > 0) {
                    // setTimeout(() => {
                    //   console.log("This message appears after a 1-second delay.");
                    // }, 1000);
                }
                item.lookupData = this.lookups.filter(x => x.name === item.subType);
            }
            if (item.type === "lookup - simple") {
                item.lookupNameControl = `${item.name}_${filterCounter}_LOOKUPNAME_CONTROL`;
                item.lookupData = this.getSimpleLookUps(item.subType);
            }
            if (item.type === "list") {
                item.listCount = 0;
                item.listControls = [];
                item.listControls.push(`${item.name}_${filterCounter}_LISTCONTROL_${item.listCount}`);
                item.listControls.forEach(x => {
                    this.filterForm.addControl(x, new FormControl());
                });
            }
            item.filterValueControl = `${item.name}_${filterCounter}_VALUE_CONTROL`;
            this.filterForm.addControl(item.filterValueControl, new FormControl(item.value));
            this.filters.push(item);
            filterCounter++;
        });
    }
    onAddItem(item) {
        if (item.type === "list") {
            const currentValue = this.filterForm.get(item.listControls[item.listCount]).value;
            if (currentValue === null || currentValue === "") {
                this.appControllerService.showMessage("Please enter a value before adding an additional item", AlertType.Warning);
                return;
            }
            item.listCount++;
            item.listControls.push(`${item.name}_LISTCONTROL_${item.listCount}`);
            this.filterForm.addControl(`${item.name}_LISTCONTROL_${item.listCount}`, new FormControl());
        }
        this.changeDetectorRef.detectChanges();
    }
    onShowHideColumns() {
        this.showHideColumns = !this.showHideColumns;
    }
    viewApplication($event) {
        this.appControllerService.selectedJobID = $event.key;
        this.router.navigate([
            AppRoutingConstants.createRouteToView(this.appControllerService.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, $event.key + "")
        ]);
    }
    getSimpleLookUps(value) {
        const lookups = LookupConstants[value];
        if (this.isStringArray(lookups)) {
            return lookups;
        }
        else {
            return lookups.map(x => x.value);
        }
    }
    /*private getLookUps() {
      const params = {
        $filter: `moduleId eq ${this.appControllerService.selectedModuleID}`
      }
      this.getLookUpsSubscription = this.http.get<ILookups>(ApiLookupConstants.URL, { params }).pipe(take(1))
        .subscribe({
          next: (response) => {
            const lookupValues: { id: number; name: string; code: string; value: string }[] = [];
            response.value.map(lookup => {
              const content = JSON.parse(lookup.content);
              if (content.code !== null && content.code !== undefined) {
                lookupValues.push({
                  id: lookup.id,
                  name: lookup.name,
                  ...content
                });
              }
            });
            lookupValues.sort((a, b) => 0 - (a.code.toLowerCase() > b.code.toLowerCase() ? -1 : 1));
            this.lookups = lookupValues;
            this.getSearches();
            return lookupValues;
          },
          error: (error) => {
            this.appControllerService.handleServerErrorMessage(ApplicationSearchConstants.COMPONENT_NAME, error, CRUDOperation.Get);
          }
        })
    }*/
    getLookUps() {
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID}`
        };
        return this.http.get(ApiLookupConstants.URL, { params }).pipe(take(1), map(response => {
            const lookupValues = [];
            response.value.map(lookup => {
                const content = JSON.parse(lookup.content);
                if (content.code !== null && content.code !== undefined) {
                    lookupValues.push({
                        id: lookup.id,
                        name: lookup.name,
                        ...content
                    });
                }
            });
            lookupValues.sort((a, b) => 0 - (a.code.toLowerCase() > b.code.toLowerCase() ? -1 : 1));
            this.lookups = lookupValues;
            return response;
        }));
    }
    isStringArray(value) {
        if (!Array.isArray(value)) {
            return false;
        }
        // All elements must be strings
        return value.every(item => typeof item === "string");
    }
    showCollapsSummary() {
        this.showSummary = !this.showSummary;
        this.changeDetectorRef.detectChanges();
    }
    createApplication() {
        this.router.navigate([
            AppRoutingConstants.createRouteToView(this.appControllerService.selectedModuleID + "", CreateApplicationRoutingConstants.CREATE_APPLICATION_ROUTE)
        ]);
    }
    addAssignedToFilter() {
        this.selectedSearchConfiguration.filters.unshift({
            name: "SystemAssignedTo",
            alias: "Assigned To",
            operator: "=",
            type: "SYSTEM_ASSIGNED_TO",
            value: "@Me"
        });
        this.changeDetectorRef.detectChanges();
    }
    static ctorParameters = () => [
        { type: Router },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AflaModuleStrategyService },
        { type: SystemModuleSettingsService },
        { type: ViewApplicationService },
        { type: RouterParamsService },
        { type: ModuleRoleService }
    ];
    static propDecorators = {
        acc: [{ type: ViewChild, args: ["accordion",] }]
    };
};
ApplicationSearchComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-application-search-new",
        providers: [aflaModuleServiceProvider],
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ApplicationSearchComponent);
export { ApplicationSearchComponent };
